/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import LocalizationComponent from '../../../Localization/LocalizationComponent';
import CLog, { LogTypes } from '../../ComponentLogger';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import OptionalBaseComponent from './OptionalBaseComponent';
import OptionalReplaceData from './OptionalReplaceData';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Removes visual components based on the configuration supplied by the RGS server. */
@cc._decorator.ccclass
export default class OptionalLocalizationComponent extends OptionalBaseComponent
{
    @property([OptionalReplaceData])
    protected replacements: OptionalReplaceData[] = [new OptionalReplaceData()];

    @property(InjectableComponent)
    protected localizationComponentRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();

    protected setContexts(): void
    {
        super.setContexts();
        this.localizationComponentRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected trigger(): void
    {
        if (!this.isDisplayKeyValid()) { return; }
        this.localizationComponentRef
                .WithValue(localizationComponent =>
                    {
                        localizationComponent.AddReplacementResourceId(this.replacements);
                    },
                    () => CLog.warn('No localization component.', LogTypes.Effect, this));
    }
}
